import React from 'react'
import { Table, Button, Modal } from 'antd'
import { connect } from 'dva'
import { withRouter } from 'react-router-dom'
import PageTable from '@/components/PageTable'
import './Team.module.less'

import DatePicker from '@/components/DatePicker'

const { RangePicker } = DatePicker

const { Column } = Table

const TeamTable = ({
  dispatch,
  teamPagination,
  teamData,
  history,
  userInfo,
}) => {
  const handleTableChange = (option) => {
    dispatch({
      type: 'center/save',
      payload: {
        teamPagination: {
          ...teamPagination,
          current: 1,
          pageSize: option.pageSize,
        },
      },
    })
    dispatch({
      type: 'center/getTeamMembers',
    })
  }

  const removeMember = (record) => {
    Modal.warning({
      onOk: () => {
        dispatch({
          type: 'center/removeMember',
          payload: {
            hash: record.userHash,
          },
        })
      },
      content: `确定移除成员？`,
      okText: '确定移除',
      okCancel: '取消',
    })
  }

  const goToMemberDetail = (id) => {
    history.push(`/hero/detail/${id}`)
  }

  const handleDateChange = (date, dateStr) => {
    dispatch({
      type: 'center/save',
      payload: {
        dateRange: dateStr,
      },
    })
    dispatch({
      type: 'center/getTeamMembers',
    })
  }

  return (
    <div styleName="member-table-container">
      <div styleName="range-container">
        <RangePicker onChange={handleDateChange} />
      </div>
      <PageTable
        onChange={handleTableChange}
        pagination={teamPagination}
        rowKey="userHash"
        dataSource={teamData}
        style={{ marginTop: '20px' }}
      >
        <Column
          title="成员信息"
          dataIndex="nickname"
          key="nickname"
          render={(text, item) => (
            <span
              onClick={() => {
                goToMemberDetail(item.userHash)
              }}
              styleName="team-table-member"
            >
              <span>{text}</span>
              <span>{item.role}</span>
            </span>
          )}
        />
        <Column title="有效漏洞" dataIndex="bugNum" key="bugNum" />
        <Column title="成长等级" dataIndex="level" key="level" />
        <Column title="贡献值" dataIndex="score" key="score" />
        <Column
          width={200}
          title="操作"
          key="operatioin"
          render={(text, record) => (
            <div>
              <Button
                type="primary"
                onClick={() => removeMember(record)}
                style={{ marginLeft: '12px' }}
                danger
                disabled={record.userHash === userInfo.userHash}
              >
                移除
              </Button>
            </div>
          )}
        />
      </PageTable>
    </div>
  )
}

export default connect(({ center, global }) => {
  return {
    teamPagination: center.teamPagination,
    teamData: center.teamData,
    userInfo: global.userInfo,
  }
})(withRouter(TeamTable))
